import React, {useContext, useEffect, useRef, useState} from 'react';
import NavbarTop from '../../components/navbar/NavbarTop';
import Sidebar from '../../components/sidebar/Sidebar';
import UserData from "../../utils/UserData";
import {
    BASE_RESOURCE_URL,
    token,
} from '../../utils/const';
import './AuthLayout.scss';
import Administration from '../../components/sidebar/administration/Administration';
import {Reports} from '../../components/sidebar/reports/Reports';
import Risks from '../../components/sidebar/risks/Risks';
import './AuthLayout.scss';
import * as SockJS from "sockjs-client";
import Stomp from "stompjs";


const AuthLayout = ({pageTitle, children}) => {

  
  const [sidebarExtra, setSidebarExtra] = useState(null);
  const [reportsExtra, setReportsExtra] = useState(null);
 
  
  const [notification, setNotification] = useState()
  const [allNotification, setAllNotification] = useState(sessionStorage.getItem("publicNotice") !== null ? sessionStorage.getItem("publicNotice") : "")
  
  const [connected, setConnected] = useState(false);
  const [notificationPublicCircle, setNotificationPublicCircle] = useState();
 // const [newChatNotification, setNewChatNotification] = useState('');
  const [numberNotification, setNumberNotification] = useState('');

  


    const url = new SockJS(`${BASE_RESOURCE_URL}/websocket?access_token=${token}`);
    const client = Stomp.over(url);
    client.reconnect_delay = 200;

    function connection() {
        client.connect({}, function (frame) {
            setConnected(true);
            // {
            //     conversationAllow &&
                // client.subscribe(`/user/queue/chat`, function (messageOutput) {
                //     setNewChatNotification(messageOutput.body)
                // }, {"Authorization": `Bearer ${token}`});
            // }

            // {
            //     notificationsGlobalView &&
                client.subscribe('/topic/public-notice', function (messageOutput) {
                    setNotification(JSON.parse(messageOutput.body));
                    setNotificationPublicCircle(true);
                    setAllNotification(`${sessionStorage.getItem("publicNotice")} ${JSON.parse(messageOutput.body).id} `)

                }, {"Authorization": `Bearer ${token}`});
            // }

            // {
            //     notificationsAllow &&
                client.subscribe(`/user/queue/notifications`, function (messageOutput) {
                    setNumberNotification(messageOutput.body)
                }, {"Authorization": `Bearer ${token}`});
            // }
        });
    }

  useEffect(() => {
    if (allNotification !== []) {
        sessionStorage.setItem("publicNotice", JSON.stringify(allNotification).replace(/\\/g, "").replace(/\"/g, ""));
    }
  }, [allNotification]);


  function disconnect() {
      if (token === undefined) {
          client.disconnect(function () {
              alert("Connection is lost! Please refresh page!")
          });
      }
      setConnected(false);
  }

  useEffect(() => {
      if (token !== undefined) {
          connection();
      } else {
          if (connected === true) {
              disconnect();
          }
      }
  }, [token]);
  
  // const headerRef = useRef(null);

  // const location = window.location.pathname.split('/');
  // const queryFolder = `/${window.location.pathname.split('/')[1]}`;
  // const query = `/${window.location.pathname.split('/').pop()}`;
  
  // useEffect(() => {
  //     setMaxHeight(headerRef.current.clientHeight + 10);
  // }, [window.location.pathname]);
  const [risksExtra, setRisksExtra] = useState(null);

  /*******  Sidebar extra controls  *******/

  const toggleSidebarExtra = (e) => {
    if (sidebarExtra === e || !e) return setSidebarExtra(null);
    setSidebarExtra(e);
  };

  const toggleReportsExtra = (e) => {
    if (reportsExtra === e || !e) return setReportsExtra(null);
    setReportsExtra(e);
  };
  const toggleRisksExtra = (e) => {
    if (risksExtra === e || !e) return setRisksExtra(null);
    setRisksExtra(e);
  };

  const handleOutsideClick = (e) => {
    const sidebar = document.getElementsByClassName('sidebar')[0];
    const sidebarExtraEl = document.getElementsByClassName('sidebar-extra')[0];
    const isNavLink = e.target.classList.contains('links');
    if (
      (!sidebar.contains(e.target) && !sidebarExtraEl.contains(e.target)) ||
      isNavLink
    )
      toggleSidebarExtra();
  };
  
  const handleReportsClick = (e) => {
    const sidebar = document.getElementsByClassName('sidebar')[0];
    const reportsExtraEl = document.getElementsByClassName('sidebar-extra')[0];
    const isNavLink = e.target.classList.contains('links');
    if (
      (!sidebar.contains(e.target) && !reportsExtraEl.contains(e.target)) ||
      isNavLink
    )
      toggleReportsExtra();
  };
    
  const handleRisksClick = (e) => {
    const sidebar = document.getElementsByClassName('sidebar')[0];
    const risksExtraEl = document.getElementsByClassName('sidebar-extra')[0];
    const isNavLink = e.target.classList.contains('links');
    if (
      (!sidebar.contains(e.target) && !risksExtraEl.contains(e.target)) ||
      isNavLink
    )
    toggleRisksExtra();
  };

  useEffect(() => {
    if (sidebarExtra) document.addEventListener('click', handleOutsideClick);
    else document.removeEventListener('click', handleOutsideClick);

    return () => document.removeEventListener('click', handleOutsideClick);
  }, [sidebarExtra]);

  useEffect(()=>{
    if (risksExtra) document.addEventListener('click', handleRisksClick);
    else document.removeEventListener('click', handleRisksClick);

    return () => document.removeEventListener('click', handleRisksClick);
  }, [risksExtra]);

  useEffect(() => {
    if (reportsExtra) document.addEventListener('click', handleReportsClick);
    else document.removeEventListener('click', handleReportsClick);

    return () => document.removeEventListener('click', handleReportsClick);
  }, [reportsExtra]);
  /******** Sidebar extra controls end  *******/

  return (
    <>
      <Sidebar toggleSidebarExtra={toggleSidebarExtra} toggleRisksExtra={toggleRisksExtra} toggleReportsExtra={toggleReportsExtra}/>
      <div className={'sidebar-extra ' + (sidebarExtra ? 'show' : 'hide') + (risksExtra ? ' show' : ' hide') + (reportsExtra ? ' show ' : ' hide ')}>
        <div className="sidebar-extra-brand">Risk management system</div>
        {sidebarExtra === 'administration' && <Administration/>}
        {risksExtra === 'risks' && <Risks/>}
        {reportsExtra === 'reports' && <Reports />}
      </div>
      <div className={'app-wrapper ' + (sidebarExtra && 'opened ') + (risksExtra && ' opened ') + (reportsExtra && ' opened ')}>
        <div className="app-header">
          <NavbarTop 
            pageTitle={pageTitle} 
            client={client}
            numberNotification={numberNotification}
            connected={connected}
          />
        </div>
        <div className="app-body" id="app-body">
          {children}
        </div>
      </div>
    </>
  );
};

export default AuthLayout;